import { Identifiable, Constraint } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeConstraint(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Constraint>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/constraints/${uuid}`,
      method: HttpMethods.DELETE,
    });
}
export { removeConstraint };
